import styled from "styled-components";

export const Container = styled.div`
  width: 90%;
  margin: 0 auto;

  margin-top: 80px;
`;
